import { useTranslation } from 'gatsby-plugin-react-i18next'
import React from 'react'

import { SCROLL_ANIMATION_DEFAULT_PROPS } from '../../constants'
import ScrollAnimation from '../scroll-animation/Container'

const DeliveryTitle: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className="meals__title">
      <ScrollAnimation {...SCROLL_ANIMATION_DEFAULT_PROPS}>
        {t('Save as much as 70% on restaurant prices.')} <br />
        {t('Now get it delivered for FREE!')}
      </ScrollAnimation>
    </div>
  )
}

export default DeliveryTitle
